// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"93de4bde","292":"2d240251","436":"95fec027","453":"0f726d9c","591":"668ee0fa","662":"86fb56ec","816":"8c454101","821":"57590b88"}[chunkId] + ".chunk.js";
};